import React from 'react';
import { Autocomplete } from '@makemydeal/dr-shared-components';
import { TextInput } from '@makemydeal/dr-shared-components/text-input';
import type { LienholderFieldProps } from './lienholderFormTypes';
import { useLienholderField } from './useLienholderField';

export type { LienholderFieldProps } from './lienholderFormTypes';

export const LienholderField: React.FC<LienholderFieldProps> = (props) => {
    const { hasLenders, autocompleteProps, textInputProps } = useLienholderField(props);

    if (hasLenders) {
        return <Autocomplete {...autocompleteProps} />;
    }

    return <TextInput {...textInputProps} />;
};
